import React from "react";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { Store } from "react-notifications-component";

const firebaseConfig = {
  apiKey: "AIzaSyAWO-35QknrIhdI_23z_yL69LannHntehI",
  authDomain: "connecme2-fe43f.firebaseapp.com",
  projectId: "connecme2-fe43f",
  storageBucket: "connecme2-fe43f.appspot.com",
  messagingSenderId: "413080738267",
  appId: "1:413080738267:web:fd350c0c1d95aafa492ffe",
  measurementId: "G-XEDBCXGHQ3",
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const getPushToken = () => {
  return getToken(messaging, {
    vapidKey:
      "BFrxo2QBUj460Nn3YREKu9S6fluLSkDVjakyGEF1_dgsSzHLBmo8FvRcKZ3OzYfl3oAFHvV3nKeyEBT7rIQaaMs",
  })
    .then((currentToken) => {
      if (currentToken) {
        return currentToken;
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

onMessage(messaging, (payload) => {
  const data = payload.data;
  const link =
    data.type === "FOLLOW"
      ? `/followers/${data.seekerId}`
      : `/messages/${data.seekerId}`;
  Store.addNotification({
    title: payload.notification.title,
    message: (
      <a href={link} style={{ color: "white" }}>
        {payload.notification.body}
      </a>
    ),
    type: "info",
    insert: "top",
    container: "top-right",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 5000,
      onScreen: false,
      showIcon: true,
    },
  });
});
